import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <CommentsSection />
        <IndexSection />
        <FAQSection />
        <MediaSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <TopicsSection />
        <AppSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}